// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_kv-0";
export var fulfillmentPanelBody = "_kv-1";